import { CDN_HOST, VIDEO_CDN_HOST,SI_HOST } from '@/plus/config'
import de from 'element-ui/src/locale/lang/de'
const diaryHost="https://si.meb.com"

export function getFullImageURLDiary (url, type = 'image', limit) {

    if (!url) return url
    let after = ''
    let last=url.substring(url.length - 2,url.length)
	if (url.indexOf(SI_HOST) > -1 && last != '-d' && last != '-o' && last != '-m') {
		after = '-o'
	}
    let before = diaryHost
    if (type === 'video') {
        after = '?vframe/jpg/offset/1/w/500'
        before = VIDEO_CDN_HOST
    }

	if (type === 'none') {
		after = ''
	}
	if (url.indexOf('http') > -1) {
		if (url.lastIndexOf('http') == 24) {
			return url.substring(24) + after
		}
		if (url.indexOf('-s') > -1 && url.indexOf('-s') != 11) return url
		else {
			if (url.indexOf('-m') != -1 || url.indexOf('-o') != -1) return url
			else return url + after
		}
    }else{
        if(type === 'image') after='-o'
    }

	if (url.indexOf('/') === 0) {
		if (!limit) return before + url + after
		else return before + url + limit
	}
	if (!limit) return before + '/' + url + after
	else return before + '/' + url + limit
}
export function getFullImageURL (url, type = 'image', limit) {
    if (!url) return url
    let after = ''
    let last=url.substring(url.length - 2,url.length)
	if ((url.indexOf(CDN_HOST) > -1 && last != '-d' && last != '-o' && last != '-m') || (url.indexOf(SI_HOST) > -1 && last != '-d' && last != '-o' && last != '-m')) {
		after = '-o'
    }
    if(last.indexOf("-") == -1) after='-o';
    let before = CDN_HOST
    if (type === 'video') {
        after = '?vframe/jpg/offset/1/w/500'
        before = VIDEO_CDN_HOST
    }

	if (type === 'none') {
		after = ''
    }
	if (url.indexOf('http') > -1) {
		if (url.lastIndexOf('http') == 24) {
			return url.substring(24) + after
        }
		if (url.indexOf('-s') > -1 && url.indexOf('-s') != 11) return url
		else {
			if (url.indexOf('-m') != -1 || url.indexOf('-o') != -1) return url
			else return url + after
		}
	}
	if (url.indexOf('/') === 0) {
		if (!limit) return before + url + after
		else return before + url + limit
	}
	if (!limit) return before + '/' + url + after
	else return before + '/' + url + limit
}

export function getFullVideoURL (url, type = 'video') {
	if (!url) return url
	let before = CDN_HOST
	if (type === 'video') {
		before = VIDEO_CDN_HOST
	}
	if (url.indexOf('http') > -1) {
		return url
	}
	if (url.indexOf('/') === 0) {
		return before + url
	}
	return before + '/' + url
}

export const CalendarDate = {
	'YYYYMMDD' () {
		const date = new Date()
		return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
	}
}

/**
 * 异步分组调用
 * @param list
 * @param size
 * @param callback
 * @returns {{totalGroup: number}}
 */
export function asynchronousPacketExecution (list, size, callback = Function) {
	let listIndex = 0
	let groupIndex = 0
	const keys = Object.keys(list)
	const length = keys.length

	const groupBy = (index) => {
		groupIndex++
		if (index < length) {
			setTimeout(() => {
				while (index < size * groupIndex) {
					callback(list[keys[index]], groupIndex, keys[index])
					index++
				}

				groupBy(index)
			}, 0)
		} else {
			groupIndex = 0
			index = 0
		}
	}

	groupBy(listIndex)

	return {
		totalGroup: groupIndex
	}
}

export function extractData (keys, target) {
	const obj = {}
	for (const key of keys) {
		const value = target[key]
		if (value === undefined || value === null) {
			console.warn('extractData', key)
		}
		obj[key] = value
	}
	return obj
}

export const guidREG = /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/

export function checkGUID(id) {
	return guidREG.test(id);
}

export function isWorkWechat() {
  return navigator.userAgent.toLowerCase().includes('wxwork');
}
